var _path, _rect, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEquipment = function SvgEquipment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 19.657a4 4 0 0 1 1.172-2.829l1.974-1.974a.5.5 0 0 1 .854.353v14.586a.5.5 0 0 1-.854.353l-1.974-1.974A4 4 0 0 1 18 25.343v-5.686Zm-4 5.686a4 4 0 0 1-1.172 2.829l-1.974 1.974a.5.5 0 0 1-.854-.353V15.207a.5.5 0 0 1 .854-.353l1.974 1.974A4 4 0 0 1 14 19.657v5.686Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 19,
    x: 24,
    y: 13,
    fill: "currentColor",
    rx: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 19,
    y: 13,
    fill: "currentColor",
    rx: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 4,
    d: "M28 14c0-6.627-5.373-12-12-12S4 7.373 4 14",
    opacity: 0.4
  })));
};
export default SvgEquipment;